import { getActiveBuildings } from "./index24.js";
import { RG_TYPE, getRgObjectsOfType } from "@project-rouge/rg-core";
import { createFacadeFromBoundary } from "@project-rouge/rg-three";
const pipeAddFacade = ([parent, { buildingIds, aggProps }]) => {
	const dataset = aggProps.dataset;
	const zones = getRgObjectsOfType(parent, RG_TYPE.Zone);
	for (const zone of zones) {
		var _aggProps$zones$zone$;
		const buildings = getActiveBuildings(zone, aggProps);
		const facadeModId = ((_aggProps$zones$zone$ = aggProps.zones[zone.uuid]) === null || _aggProps$zones$zone$ === void 0 ? void 0 : _aggProps$zones$zone$.facadeId) ?? dataset.modulousIds.facadeId;
		for (const building of buildings) {
			if (buildingIds && !buildingIds.includes(building.uuid)) continue;
			createFacadeFromBoundary({
				building,
				rvDataList: dataset.rvData,
				facadeModId
			});
		}
	}
	return [parent, void 0];
};
export { pipeAddFacade };

//# sourceMappingURL=index28.js.map